import { RefObject, useEffect, useState } from 'react';
import { TMultiSelectItem } from '../../ui/multi-select';

export const useHiddenCount = <T>(selected: TMultiSelectItem<T>[], chipsRef: RefObject<HTMLDivElement>) => {
  const [hiddenCount, setHiddenCount] = useState(0);

  useEffect(() => {
    const container = chipsRef.current;
    if (!container) return;

    const observer = new IntersectionObserver(
      entries => {
        const hiddenTags = entries.filter(entry => !entry.isIntersecting);
        setHiddenCount(hiddenTags.length);
      },
      {
        root: container,
        threshold: 1.0,
        rootMargin: '0px',
      },
    );

    const elements = container.querySelectorAll('.tag');
    elements.forEach(el => observer.observe(el));

    return () => {
      observer.disconnect();
    };
  }, [selected, hiddenCount, chipsRef]);

  return {
    hiddenCount
  };
};
